import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'StatesTransitions';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_TRANSITIONSBYSTATE";
  return _fetchEntitiesService(dataSlice,events);
}

export function fetchTransitionsByWorkflow(dataSlice) {
  dataSlice.dataUrl.code="GET_TRANSITIONSBYWORKFLOW";
  return _fetchEntitiesService(dataSlice,events);
}
/*export function createEntityService(dataSlice) {
  dataSlice.dataUrl.code="POST_TRANSITIONSBYWORKFLOW";
  return _createEntityService(dataSlice,events);
}*/

export function updateEntityService(dataSlice) {
  dataSlice.dataUrl.code="PUT_TRANSITIONSBYWORKFLOW";
  dataSlice.dataUpdate.isPost=true;
  return _updateEntityService(dataSlice,events);
}

export function bulkUpdateTransitionsActionsService(dataSlice) {
  dataSlice.dataUrl.code="PUT_BULKTRANSITIONACTIONS";
  dataSlice.dataUpdate.isPost=true;
  return _updateEntityService(dataSlice,events);
}

export function bulkUpdateTransitionsRolesService(dataSlice) {
  dataSlice.dataUrl.code="PUT_BULKTRANSITIONROLES";
  dataSlice.dataUpdate.isPost=true;
  return _updateEntityService(dataSlice,events);
}

/*export function deleteEntityService(dataSlice) {
  dataSlice.dataUrl.code="DELETE_STATES";
  return _deleteEntityService(dataSlice,events);
}*/